import React from 'react';
import PropTypes from 'prop-types';
import './Tab.css';

class Tab extends React.Component {
  handleDragStart = (e) => {
    e.dataTransfer.setData('text/plain', this.props.tabIndex);
  };

  handleDragOver = (e) => {
    e.preventDefault();
  };

  handleDrop = (e) => {
    e.preventDefault();
    const draggedTabIndex = e.dataTransfer.getData('text/plain');
    const targetTabIndex = this.props.tabIndex !== undefined ? this.props.tabIndex : this.props.tabs.length;
    this.props.onMove(draggedTabIndex, targetTabIndex);
  };

  render() {
    const {
      onMouseDown, onClose, onRename, isTabActive, name,
    } = this.props;
    return (
      <li
        key={this.key}
        className="nav-item"
        draggable
        onDragStart={this.handleDragStart}
        onDragOver={this.handleDragOver}
        onDrop={this.handleDrop}
      >
        <button
          type="button"
          onMouseDown={() => onMouseDown(this)}
          className={`${isTabActive === true ? 'active' : 'tab-unfocused'} nav-link`}
        >
          {name.concat('   ')}
          <span
            tabIndex={0}
            role="button"
            onKeyPress={() => ''}
            className="btn tab-close btn-sm"
            onMouseDown={() => onClose(this)}
          >
            x
          </span>
          <span
            tabIndex={0}
            role="button"
            onKeyPress={() => ''}
            className="btn tab-close btn-sm"
            onMouseDown={() => onRename(this)}
          >
            ✎
          </span>
        </button>
      </li>
    );
  }
}

Tab.defaultProps = {
  name: '',
  isTabActive: false,
};

Tab.propTypes = {
  name: PropTypes.string,
  isTabActive: PropTypes.bool,
  onMouseDown: PropTypes.instanceOf(Function).isRequired,
  onClose: PropTypes.instanceOf(Function).isRequired,
  onRename: PropTypes.instanceOf(Function).isRequired,
  onMove: PropTypes.instanceOf(Function).isRequired,
  tabIndex: PropTypes.number.isRequired,
  tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default Tab;
